// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionSelectorSection-root-3f23db56aa3e71a240e9f3096116c6d0","active":"SectionSelectorSection-active-ea51b7550341a30663e814949d8d1771"};